import deepExtend from 'deep-extend';
import DataStore from './DataStore';

// TODO: Create a file for an encryption when app first launches...
export default options => {
    return vuex => {
        const store = vuex.$dataStore = new DataStore(options);
        
        vuex.replaceState(deepExtend(vuex.state, store.data));

        vuex.watch(state => {
            return state;
        }, value => {
            store.data = value;
        }, {
            deep: true
        });

        vuex.resetStateToDefault = value => {
            vuex.replaceState(vuex.getters.defaultState);
        };
    };
};
